var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.25,
    height: 17.342,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 195",
    d: "M13.559 17.218H.8a.675.675 0 01-.675-.675V3.781A.675.675 0 01.8 3.106h12.759a.675.675 0 01.675.675v12.762a.675.675 0 01-.675.675zM1.475 15.867h11.409V4.459H1.475z",
    fill: "#5300f2",
    stroke: "#5300f2",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 196",
    d: "M16.449 14.234h-1.37a.675.675 0 110-1.35h.7V1.476H4.366v.749a.675.675 0 01-1.35 0V.8a.675.675 0 01.675-.675h12.758a.675.675 0 01.675.675v12.759a.675.675 0 01-.675.675z",
    fill: "#5300f2",
    stroke: "#5300f2",
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.f32becd3bcd17036622a1feabbc0d337.svg";
export { ForwardRef as ReactComponent };